import React from 'react';

export const TrackIdReading = () => {
  return <>Não é mais utilizado.</>;
};
